module.exports = __webpack_public_path__ + "img/tabicon_9.c188f711.png";